/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener('DOMContentLoaded', () => {
    const headings = document.querySelectorAll('.richtext-heading');

    function hexToRgb(hex) {
        hex = hex.replace(';', '').trim();

        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (result) {
            return `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`;
        } else {
            return null;
        }
    }

    headings.forEach(heading => {

        const anchor = heading.querySelector('a');

        heading.addEventListener('mouseover', () => {
            let hoverColor = heading.getAttribute('data-headingcolor');

            if (hoverColor) {
                if (/^#[0-9A-F]{6};?$/i.test(hoverColor)) {
                    hoverColor = hexToRgb(hoverColor);
                }

                anchor.style.color = hoverColor;

            }
        });

        heading.addEventListener('mouseout', () => {
            let hoverColor = heading.getAttribute('data-headingcolor');
            if (hoverColor) {
                anchor.removeAttribute('style');
            }
        });
    });
});